import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../../css/DLT.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import Pagination from "../common/Pagination";
import { BiEditAlt } from "react-icons/bi";
import { IoEyeOutline } from "react-icons/io5";
import EntityModal from "./EntityModal";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";
import Button from "../customButton/Button";
import AddIcon from "../../../src/assets/Icons/AddIcon.svg";

const EntityIDs = ({ openModal, customerCode, name }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize] = useState(10);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [modalType, setModalType] = useState("");
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    setLoading(true);
    fetchEntitydata(1);
  }, []);

  const handleViewEntity = (entity, type) => {
    setSelectedEntity({
      name: entity?.entityName,
      id: entity?.entityId,
      username: entity?.name,
    });
    setModalType(type);
    setOpenPopup(true);
  };

  const handleClose = () => setOpenPopup(false);

  const fetchEntitydata = async (page) => {
    const data = {
      username: loggedInUserName,
      userCode: customerCode,
    };

    try {
      const response = await axiosPostApi(
        `${apiList.DLT_FETCH_ENTITY}?pageSize=${pageSize}&pageNo=${page}`,
        data
      );
      setEntities(response?.data?.data || []);
      setPageDetails(response?.data?.pageDetails || null);
    } catch (error) {
      console.error("Failed to fetch entity data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    openModal();
  };

  const pageSizeCount = pageDetails ? pageDetails.pageSize : 0;
  const totalRecord = pageDetails ? pageDetails.totalRecords : 0;

  const getActionItems = (entity) => {
    const actions = [];

    if (user?.data?.userRole === "ADMK") {
      actions.push({
        icon: <BiEditAlt style={{ marginRight: "10px" }} />,
        label: "Edit",
        onClick: (e) => {
          e.stopPropagation();
          handleViewEntity(entity, "modify");
        },
      });
    }

    actions.push({
      icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
      label: "View",
      onClick: (e) => {
        e.stopPropagation();
        handleViewEntity(entity, "view");
      },
    });

    return actions;
  };

  return (
    <div className="entity-ids-container">
      <div className="flex first-tab-controls justify-end">
        {user?.data?.userRole === "ADMK" && (
          <Button
            label="Add"
            icon={AddIcon}
            onClick={handleSwitch}
            className="pr-2"
          />
        )}
      </div>

      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        <div className="table-container !bg-[#FFFFFF] !shadow-none !px-0">
          {entities.length > 0 ? (
            <>
              <div className="table-wrapper">
                <table className="custom-table">
                  <thead className="bg-[#F1FFFF]">
                    <tr>
                      <th className="!border-b-0">Sr No</th>
                      <th className="!border-b-0">Entity ID</th>
                      <th className="!border-b-0">Entity Name</th>
                      <th className="!border-b-0">Status</th>
                      <th className="!border-b-0">Created Date-Time</th>
                      <th className="!border-b-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entities.map((entity, index) => (
                      <tr key={entity.id}>
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>{entity?.entityId || "-"}</td>
                        <td>{entity?.entityName || "-"}</td>
                        <td>
                          <span
                            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border`}
                            style={{
                              backgroundColor:
                                entity.entityStatus === "ACTIVE"
                                  ? "#e6f9ec"
                                  : "#fdecea",
                              borderColor:
                                entity.entityStatus === "ACTIVE"
                                  ? "#55cd69"
                                  : "#fb4a3f",
                              color:
                                entity.entityStatus === "ACTIVE"
                                  ? "#2e9b47"
                                  : "#d4352c",
                            }}
                          >
                            <span
                              className="w-2 h-2 rounded-full mr-2"
                              style={{
                                backgroundColor:
                                  entity.entityStatus === "ACTIVE"
                                    ? "#55cd69"
                                    : "#fb4a3f",
                              }}
                            ></span>
                            {entity.entityStatus}
                          </span>
                        </td>
                        <td>{entity?.entityDate || "-"}</td>
                        <td className="actions" style={{ overflow: "visible" }}>
                          <Popover>
                            {({ open, close }) => (
                              <>
                                <Popover.Button
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    display: "inline-block",
                                    padding: "0 10px",
                                    background: "none",
                                    border: "none",
                                  }}
                                >
                                  ⋮
                                </Popover.Button>
                                <Transition
                                  as={React.Fragment}
                                  enter="transition ease-out duration-200"
                                  enterFrom="opacity-0 translate-y-1"
                                  enterTo="opacity-100 translate-y-0"
                                  leave="transition ease-in duration-150"
                                  leaveFrom="opacity-100 translate-y-0"
                                  leaveTo="opacity-0 translate-y-1"
                                >
                                  <Popover.Panel
                                    style={{
                                      position: "absolute",
                                      zIndex: 2000,
                                      minWidth: "220px",
                                      backgroundColor: "#ffffff",
                                      boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                                      border: "1px solid #d1d5db",
                                      borderRadius: "8px",
                                      padding: "8px 0",
                                      overflow: "visible",
                                    }}
                                  >
                                    {getActionItems(entity).map(
                                      (action, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 20px",
                                            cursor: "pointer",
                                            color: "#333",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            transition: "background-color 0.2s",
                                            whiteSpace: "nowrap",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.backgroundColor =
                                              "#f0f0f0")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.backgroundColor =
                                              "#ffffff")
                                          }
                                          onClick={(e) => {
                                            action.onClick(e);
                                            close();
                                          }}
                                        >
                                          {action.icon}
                                          <span>{action.label}</span>
                                        </div>
                                      )
                                    )}
                                  </Popover.Panel>
                                </Transition>
                              </>
                            )}
                          </Popover>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-3">
                <Pagination
                  currentPage={currentPage}
                  totalCount={totalRecord}
                  pageSize={pageSizeCount}
                  onPageChange={(page) => {
                    setCurrentPage(page);
                    fetchEntitydata(page);
                  }}
                />
              </div>
            </>
          ) : (
            <p className="no-data-message">No data available</p>
          )}
        </div>
      )}
      <EntityModal
        show={openPopup}
        handleClose={handleClose}
        customerCode={customerCode}
        name={name}
        entityDetails={selectedEntity}
        modalType={modalType}
        handleShowTable={() => fetchEntitydata(1)}
      />
    </div>
  );
};

export default EntityIDs;
